/**
 * Enum for rider
 */
export enum RiderNames {
  ACCIDENTAL_DEATH = 'ACCIDENTAL_DEATH',
  CARE4LIFE = 'CARE4LIFE',
  LIFETIME_INCOME = 'LIFETIME_INCOME',
  OVERLOAN_PROTECTION = 'OVERLOAN_PROTECTION',
  TERMINAL_ILLNESS = 'TERMINAL_ILLNESS',
  WAIVER_OF_SPECIFIED_PREMIUM = 'WAIVER_OF_SPECIFIED_PREMIUM',
  ETHOS_PERKS = 'ETHOS_PERKS',
  VARIABLE_LOAN = 'VARIABLE_LOAN',
  LIVING_BENEFITS = 'LIVING_BENEFITS',
  CHRONIC_ILLNESS = 'CHRONIC_ILLNESS',
  CRITICAL_ILLNESS = 'CRITICAL_ILLNESS',

  // sahara rider
  RETURN_PREMIUM_DEATH_BENEFIT_ENDORSEMENT = 'RETURN_PREMIUM_DEATH_BENEFIT_ENDORSEMENT',
  ACCIDENTAL_DEATH_BENEFIT = 'ACCIDENTAL_DEATH_BENEFIT',
  WAIVER_MONTHLY_DEDUCTIONS = 'WAIVER_MONTHLY_DEDUCTIONS',
  FLEXIBLE_BENEFIT = 'FLEXIBLE_BENEFIT',
  ADBE_CRITICAL = 'ADBE_CRITICAL',
  ADBE_CHRONIC = 'ADBE_CHRONIC',
  ADBE_TERMINAL = 'ADBE_TERMINAL',
}

export const getRiderLabel = (rider: RiderNames | string) => {
  switch (rider) {
    case RiderNames.RETURN_PREMIUM_DEATH_BENEFIT_ENDORSEMENT:
      return 'Return of Premium Death Benefit Endorsement';
    case RiderNames.ACCIDENTAL_DEATH_BENEFIT:
      return 'Accidental Death Benefit';
    case RiderNames.ADBE_CHRONIC:
      return 'Accelerated Death Benefit Endorsement (ADBE) for Chronic Illness';
    case RiderNames.ADBE_CRITICAL:
      return 'Accelerated Death Benefit Endorsement (ADBE) for Critical Illness';
    case RiderNames.ADBE_TERMINAL:
      return 'Accelerated Death Benefit Endorsement (ADBE) for Terminal Illness';
    case RiderNames.FLEXIBLE_BENEFIT:
      return 'Flexible Benefit';
    case RiderNames.WAIVER_MONTHLY_DEDUCTIONS:
      return 'Waiver of Monthly Deductions';
    case RiderNames.CHRONIC_ILLNESS:
      return 'Chronic Illness';
    case RiderNames.CRITICAL_ILLNESS:
      return 'Critical Illness';
    case RiderNames.TERMINAL_ILLNESS:
      return 'Terminal Illness';
    case RiderNames.WAIVER_OF_SPECIFIED_PREMIUM:
      return 'Waiver of Specified Premium';
    case RiderNames.CARE4LIFE:
      return 'Care4Life';
    case RiderNames.ACCIDENTAL_DEATH:
      return 'Accidental Death Benefit';
    case RiderNames.LIVING_BENEFITS:
      return 'Living Benefits';
    case RiderNames.LIFETIME_INCOME:
      return 'Lifetime Income';
    case RiderNames.OVERLOAN_PROTECTION:
      return 'Overloan Protection';
    case RiderNames.ETHOS_PERKS:
      return 'Ethos Perks';
    case RiderNames.VARIABLE_LOAN:
      return 'Variable Loan';
    default:
      return rider;
  }
};
